import { useQuery } from "@tanstack/react-query";
import { GetDashboard, GetDashboardResponse } from "./api";

type Props<T> = {
  onSuccess?: (data: T) => void;
  onError?: (error: any) => void;
  queryKey?: string;
  url?: string;
};

export const useGetDashboard = (
  props?: Props<GetDashboardResponse>
) => {
  const { data, isLoading, isError, error } = useQuery<GetDashboardResponse>(
    [props?.queryKey || "dashboard"],
    () => GetDashboard(props?.url),
    {
      onSuccess: props?.onSuccess,
      onError: props?.onError,
    }
  );
  return { data, isLoading, isError, error };
};
